/* global Vue, Swiper */

import CldImg from './CldImg'

export default {
  name: 'PropertyCardGallery',
  components: { CldImg },
  template: `
    <div class="property-card__gallery">
      <div class="swiper" ref="slider">
        <div class="swiper-wrapper">
          <div v-for="(image, index) in property.propertyListingGallery" class="swiper-slide property-card__image">
            <CldImg :src="image" :alt="property.title" set-height preload />
            <span v-if="showDisclaimer || property.title.toLowerCase().includes('marjan')" class="image-disclaimer">{{ imageDisclaimer }}</span>
          </div>
        </div>
      </div>
      <div class="card-slider__navigation">
        <div class="swiper-button-prev" ref="prev"></div>
        <div class="swiper-button-next" ref="next"></div>
      </div>
      <img
        v-if="property.groupLogoCircle && !imageDisclaimer"
        :src="property.groupLogoCircle"
        :alt="property.group"
        class="property-card__group-logo"
        loading="lazy"
        width="44"
        height="40">
      <img
        v-else-if="property.awardLogo && !imageDisclaimer"
        :src="property.awardLogo"
        class="property-card__award-logo"
        loading="lazy"
        width="110"
        height="110">
    </div>
  `,
  props: {
    property: {
      type: Object,
      required: true,
    },
  },
  setup (props) {
    const slider = Vue.ref(null)
    const prev = Vue.ref(null)
    const next = Vue.ref(null)

    const imageDisclaimer = Vue.ref(window.IMAGE_DISCLAIMER || '')
    const showDisclaimer = Vue.ref(props.property.title.toLowerCase().includes('marjan'))

    let swiper = null

    Vue.onMounted(() => {
      swiper = new Swiper(slider.value, {
        loop: true,
        navigation: {
          nextEl: next.value,
          prevEl: prev.value,
        },
      })
    })

    return {
      imageDisclaimer,
      showDisclaimer,
      slider,
      swiper,
      prev,
      next,
    }
  },
}
